export function validateSurfaceSample(sample) {
  if (!sample) return { valid: false, errors: ['sample is null'] };
  const errors = [];
  if (!sample.sample_id) errors.push('missing sample_id');
  if (!sample.surface_sample_type) errors.push('missing surface_sample_type');
  if (sample.latitude == null && sample.longitude == null && sample.easting == null && sample.northing == null) {
    errors.push('missing coordinates (lat/lng or easting/northing)');
  }
  return { valid: errors.length === 0, errors };
}

export function formatSampleLabel(sample) {
  if (!sample) return '';
  const id = sample.datasource_surface_sample_id || sample.sample_id || '';
  const type = sample.surface_sample_type || '';
  return [id, type].filter(Boolean).join(' — ');
}

import Papa from 'papaparse';

export function parseSurfaceSamples(csvText) {
  if (!csvText) return { rows: [] };
  const { data } = Papa.parse(csvText, { header: true, skipEmptyLines: true, dynamicTyping: true });
  const rows = (data || []).filter((row) => {
    const result = validateSurfaceSample(row);
    return result.valid;
  });
  return { rows };
}
